'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_shopping$package$StoreCartId$() {
  this.a9Q = 0;
  this.a9R = 0;
  $n_Lmealorama_shopping$package$StoreCartId$ = this;
  $m_Lmealorama_shopping$package$StoreCartId$();
  this.a9Q = 0;
  this.a9R = 0;
}
export { $c_Lmealorama_shopping$package$StoreCartId$ as $c_Lmealorama_shopping$package$StoreCartId$ };
$p = $c_Lmealorama_shopping$package$StoreCartId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_shopping$package$StoreCartId$;
/** @constructor */
function $h_Lmealorama_shopping$package$StoreCartId$() {
}
export { $h_Lmealorama_shopping$package$StoreCartId$ as $h_Lmealorama_shopping$package$StoreCartId$ };
$h_Lmealorama_shopping$package$StoreCartId$.prototype = $p;
var $d_Lmealorama_shopping$package$StoreCartId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_shopping$package$StoreCartId$, "mealorama.shopping$package$StoreCartId$", ({
  LU: 1
}));
export { $d_Lmealorama_shopping$package$StoreCartId$ as $d_Lmealorama_shopping$package$StoreCartId$ };
var $n_Lmealorama_shopping$package$StoreCartId$;
function $m_Lmealorama_shopping$package$StoreCartId$() {
  if ((!$n_Lmealorama_shopping$package$StoreCartId$)) {
    $n_Lmealorama_shopping$package$StoreCartId$ = new $c_Lmealorama_shopping$package$StoreCartId$();
  }
  return $n_Lmealorama_shopping$package$StoreCartId$;
}
export { $m_Lmealorama_shopping$package$StoreCartId$ as $m_Lmealorama_shopping$package$StoreCartId$ };
//# sourceMappingURL=mealorama.shopping$package$-Store-Cart-Id$.js.map
